import React from 'react';
import { GoTo, Direction } from 'components/common/GoTo';
import Wahanda from 'common/wahanda';
import { Reconnect } from 'src/federation/Reconnect';
import style from './style.scss';

export const SelfEmploymentReportsPage = () => (
  <>
    <GoTo className={style.linkBack} href="/" direction={Direction.backward}>
      {Wahanda.lang.shared.navigation.back}
    </GoTo>
    <Reconnect name="SelfEmploymentReportsPage" />
  </>
);
